
import { defineComponent, getCurrentInstance, toRefs, ref, reactive, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from '@/store/index'
import { CouponShape, CouponType, CouponStatus, CouponActiveStatus } from '@/enums/coupon'
import { joinParams } from '@/utils'
import { getCouponList, getActivationList, getCancelList, getSoldList, getSoldLog, saveCheck, cancelCoupon, checkActivation,onPowerApi } from '@/apis/coupon'
import { getCompanyListApi } from '@/apis/merchant'
import { getSaleChannelList } from '@/apis/channel'
import { getSaleList } from '@/apis/admin'
import Pagination  from '@/components/Pagination.vue'
import Keys from '@/constant/key'
interface ruleTitle {
    id:     number,     // ID
    name:   string,     // 名称
}
export default defineComponent({
name: 'CouponList',
components: { Pagination },
setup() {
    const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    
    const pageType:any = route.meta.title   // 当前页面类型：卡券列表（通过query.id-券包ID获取卡券）、激活列表、作废列表
    const state = reactive({
        filters: {
            coupon_id:          route.query.id || null,   // 券包 ID
            ids:                '',     // 当前操作券包ID
            start_id:           '',     // 券码开始 ID
            end_id:             '',     // 券码结束 ID
            status:             '',     // 券码状态
            page:               1,      // 页码
            page_size:          10,     // 每页显示条数
            sale_channel_id:    undefined,  // 销售渠道 ID
            close_start_time:   '',     // 卡激活开始时间
            close_end_time:     '',     // 卡激活结束时间
        },
        tableData:          [],     // 表格数据
        total:              0,      // 表格总条数
        selectedList:       [],     // 选中卡券
        
        dialogVisible:      false,  // 弹框
        noticeDialog:    false,  // 关卡弹框
        companyList:        [],     // 公司列表
        saleList:           [],     // 销售人员列表
        saleChannelList:    [],     // 销售渠道列表
        saleListProps:      {
            label: 'company_all',
            value: 'id'
        },
        props:{
            expandTrigger: 'hover',
            value:'id',
            label:'name',
            multiple: true,
            checkStrictly: true,
        },
        options:[],
        powerName:false,
        validYears: Array.from({ length: 10 }, (_, index) => index +1), // 生成1到10的年份数组
        cardData: {
            quantity: '',     // 卡券数量
            amount: '',     // 共计金额
        },
        buyRule:            [],     // 购买权限接口返回
        remark:                 '',     // 驳回原因
        msg:                    '',     // 作废原因
    })
    const couponPowerList = ref<ruleTitle[]>([])
    
        
    // 获取表格数据
    const getList = async () => {
        const {close_start_time, close_end_time} = state.filters
        if(close_start_time && !close_end_time) return  proxy.$message({ type: 'error', message: '请选择结束时间' })
        proxy.$http.get('/admin/coupons/closeCouponSaleLog', state.filters).then(res => {
            const { code, data, msg } = res
            if( code == 200){
                state.tableData = data.data
                state.total = data.total
            } else {
                state.tableData = []
                state.total = 0
                return proxy.$message({ type: 'error', message: msg })
            }
           
        })
    }
    // 搜索
    const onSearch = () => {
        state.filters.page = 1
        getList()
    }
    // 获取公司列表
    const onGetCompanyList = async () => {
        const { code, data, msg } = await getCompanyListApi() as any
        if (code != 0) return proxy.$message({ type: 'error', message: msg })
        state.companyList = data
    }
    // 获取销售渠道列表
    const onGetSaleChannelList = async () => {
        const { code, data, msg } = await getSaleChannelList() as any
        if (code != 200) return proxy.$message({ type: 'error', message: msg })
        state.saleChannelList = data
    }
    // 公司搜索联想
    const onCompanySearch = (queryString, cb) => {
        const results = queryString ? state.companyList.filter((item:any) => item.name.indexOf(queryString)>-1) : state.companyList
        cb(results)
    }
    // 销售渠道搜索联想
    const onSaleChannelSearch = (queryString, cb) => {
        const results = queryString ? state.saleChannelList.filter((item:any) => (item.company_all && item.company_all.indexOf(queryString)>-1)) : state.saleChannelList
        cb(results)
    }
    // 获取销售人员列表
    const onGetSaleList = async () => {
        const { code, data, msg } = await getSaleList() as any
        if (code != 200) return proxy.$message({ type: 'error', message: msg })
        state.saleList = data
    }
    // 批量导出
    const onExport = () => {
        let exportUrl = ''
        exportUrl = '/admin/coupons/closeCouponSaleLog'
        window.open(Keys.baseUrl + exportUrl + '?' + joinParams({...state.filters,is_export:1, user_id:store.state.user.userInfo.id}))
    }
    //获取权限列表
    const getPower = () => {
        proxy.$http.get('/admin/coupons/getCouponRuleData').then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            couponPowerList.value = data.rule_title
            state.options = data.rule_list
            //@ts-ignore
            state.buyRule = data.buy_rule
        })
    }
    // 打开关卡弹窗
    const openCardDialog = () => {
        proxy.$http.post('/admin/coupons/closeCouponSaleLog', {is_check:1,...state.filters}).then(res => {
            const { code, data, msg } = res
            if (code == 200) {
                Object.assign(state.cardData, data)
                state.noticeDialog = true
            } else {
                proxy.$message({ type: 'error', message: msg }) 
            }
        })
    }
    // 关闭关卡弹窗
    const closeCardDialog = () => {
        state.noticeDialog = false
        state.cardData.quantity = ''
        state.cardData.amount = ''
    }
    const switchCard = () => {
        proxy.$http.post('/admin/coupons/closeCouponSaleLog', {is_check:2,...state.filters}).then(res => {
            const { code, data, msg } = res
            if (code == 200) {
                proxy.$message({ type: 'success', message: msg }) 
                closeCardDialog()
                getList()
            } else {
                proxy.$message({ type: 'error', message: msg }) 
            }
        }) 
    }
    
    // 分页
    const onPageChange = (val:number) => {
        state.filters.page = val
        getList()
    }
    // 每页显示条数
    const onSizeChange = (val) => {
        state.filters.page_size = val
        getList()
    }
   
    onGetCompanyList() // 获取公司列表
    onGetSaleChannelList() // 获取销售渠道列表
    onGetSaleList() // 获取销售人员列表
    getList()
    return { pageType, store, ...toRefs(state), CouponShape, CouponType, CouponStatus, CouponActiveStatus, onPageChange, onSizeChange, onExport, onSearch, onSaleChannelSearch, onCompanySearch,getPower,couponPowerList,router,switchCard,openCardDialog,closeCardDialog }
}
})
